// extracted by mini-css-extract-plugin
export default {"container":"AreaList_container__CMPYE","pagination":"AreaList_pagination__Zf0As"};